import useAddVodProductMutation from 'hooks/useAddVodProductMutation.js';
import { useEffect, useRef } from 'react';
import useVodProductsQuery from 'hooks/useVodProductsQuery.js';
import useFetchProductMutation from 'components/ProductImport/useFetchProductMutation.js';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';
import useProducts from 'pages/CatalogProducts/hooks/useProducts.js';
import useCreateCatalogueProductMutation from 'pages/CatalogProducts/hooks/useCreateCatalogueProductMutation.js';

const noop = () => {};

export const exampleProductUrl = 'https://demo.bambuser.com/product/black-linen-blazer';

const useCreateExampleProduct = () => {
  const { features: { productCatalogProductsVODEnabled } } = useFeatureContext();

  // VOD hooks
  const { data: { data: vodProducts = [] } = {}, isFetched: isVodProductsFetched } = useVodProductsQuery({}, {
    enabled: !productCatalogProductsVODEnabled,
  });
  const { mutate: addVodProduct } = useAddVodProductMutation({
    onSuccess: noop,
    onError: noop,
    onSettled: noop,
  });

  // Catalog hooks
  const { data: { items: catalogProducts = [] } = {}, isFetched: isCatalogProductsFetched } = useProducts({
    enabled: productCatalogProductsVODEnabled,
  });
  const { mutate: createCatalogueProduct } = useCreateCatalogueProductMutation({
    onSuccess: noop,
    onError: noop,
    onSettled: noop,
  });

  const { mutate: fetchProduct } = useFetchProductMutation({
    catalog: productCatalogProductsVODEnabled,
    onSuccess: (data) => {
      const body = data.body;
      if (productCatalogProductsVODEnabled) {
        const product = {
          id: body.productReference,
          title: body.title,
          link: body.publicUrl,
          image_link: body.thumbnail,
          price: body.discountedPrice || body.price || 0,
          currency: body.currency,
        };
        createCatalogueProduct({ product });
      } else {
        addVodProduct({ ...body, opts: { withPlatformEvent: false } });
      }
    },
    onError: noop,
  });

  const isProductsFetched = productCatalogProductsVODEnabled ? isCatalogProductsFetched : isVodProductsFetched;
  const products = productCatalogProductsVODEnabled ? catalogProducts : vodProducts;

  const hasAttempted = useRef(false);
  useEffect(() => {
    if (
      isProductsFetched &&
      products.length === 0 &&
      !hasAttempted.current
    ) {
      hasAttempted.current = true;
      fetchProduct({
        url: exampleProductUrl,
      });
    }
  }, [fetchProduct, isProductsFetched, products.length, productCatalogProductsVODEnabled]);
};

export default useCreateExampleProduct;
